export const avatarStyles = theme => ({
  backgroundColor: theme.palette.warning.light,
  height: 24,
  marginRight: theme.spacing(1),
  width: 24,
});

export const confirmationMessageStyles = theme => ({
  fontWeight: 700,
  margin: theme.spacing(2, 0),
  textAlign: 'center',
});

export const confirmationValueStyles = theme => ({
  color: theme.palette.primary.dark,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
});

export const dialogContainerStyles = {
  maxHeight: '95%',
};

export const inputSubCaptionStyles = theme => ({
  margin: theme.spacing(0.5, 0, 1),
  paddingLeft: theme.spacing(2),
});

export const warningTextStyles = {
  alignSelf: 'center',
};
